import { useMutation } from '@tanstack/react-query';
import { apiClient } from '../apiClient';
import { updateCacheArray, CACHE_ACTIONS } from '../cacheClient';
import { getQueryKeyBase, MUTATION_KEYS } from '../queryClient';
import { getQueryKey as getQueryKeyCriterias } from './useCriterias';

// Config
import { crudConfig } from '../../../conf/criteria';

export const getMutationKey = getQueryKeyBase.bind(null, MUTATION_KEYS.CRITERIA_IMPORT);

export const useImportCriteria = ({ sessionToken, onSuccessCb, onErrorCb, onSettledCb }) => {
    const Client = apiClient(crudConfig);

    return useMutation({
        mutationKey: getMutationKey(),
        mutationFn: (file) => Client.import(sessionToken, file),
        onSuccess: (data, error, variables, context) => {
            onSuccessCb?.(data, error, variables, context);
            updateCacheArray({
                queryKey: getQueryKeyCriterias(),
                action: CACHE_ACTIONS.INSERT,
                primaryKey: crudConfig.primaryKey,
                data
            });
        },
        onError: (error) => {
            console.log('Error', error);
            onErrorCb?.(error);
        },
        onSettled: (...args) => {
            onSettledCb?.(...args);
        },
        refetchOnWindowFocus: false
    });
};
